<!-- Layout 5: Grime Fighters Layout - Title, Description, Image Row -->
<div class="section-container layout-5-container" *ngIf="data?.title || data?.description">
  <!-- Title at Top -->
  <div class="layout-5-header">
    <h2 class="section-title"
        *ngIf="data?.title"
        [style.color]="headingColor"
        [style.font-family]="headingFont"
        [ngStyle]="titleStyles || data?.titleStyle">{{ data?.title }}</h2>
    
    <!-- Description -->
    <p class="section-description"
       *ngIf="data?.description"
       [style.color]="paragraphColor"
       [style.font-family]="bodyFont">
      {{ data?.description }}
    </p>
  </div>
  
  <!-- Image Row (Grime Fighters) -->
  <div class="layout-5-image-row" *ngIf="getImageSrc()">
    <img [src]="getImageSrc()" 
         [alt]="getImageAlt()"
         [style.object-fit]="getImageObjectFit()"
         class="grime-fighters-image">
  </div>
  
  <!-- Button Below Images -->
  <div class="layout-5-footer" *ngIf="data?.buttonText">
    <button class="section-btn"
            [style.background-color]="primaryColor"
            [style.color]="headingColor"
            (click)="onButtonClick(data?.buttonLink, $event)">{{ data?.buttonText }}</button>
  </div>
</div>

